/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Submit_SuccessInputs */

const vi_stocktake_submit_success = /** @type {(inputs: Stocktake_Submit_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã submit phiếu kiểm`)
};

/**

* @param {Stocktake_Submit_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_submit_success = /** @type {((inputs?: Stocktake_Submit_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Submit_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_submit_success(inputs)
});